import { useEffect } from 'react';

import { kibanaLogger } from '../../../shared/logging/kibana-logger';
import type { DeliveryMethod } from '../data-builder.store';
import { useDataBuilderSchema } from './useDataBuilderQuery';

const DOWNLOAD_ONLY_FALLBACK: DeliveryMethod[] = ['download'];

let hasLoggedMissingDeliveryMethods = false;

// Test-only: resets the once-per-session log guard between tests.
export const resetMissingDeliveryMethodsLog = (): void => {
  hasLoggedMissingDeliveryMethods = false;
};

type UseAvailableDeliveryMethodsResult = {
  availableMethods: DeliveryMethod[];
  isLoaded: boolean;
};

export const useAvailableDeliveryMethods =
  (): UseAvailableDeliveryMethodsResult => {
    const { data } = useDataBuilderSchema();
    const isLoaded = data !== undefined;
    const deliveryMethods = data?.delivery_methods;
    const hasMethods =
      deliveryMethods !== undefined && deliveryMethods.length > 0;

    useEffect(() => {
      if (!isLoaded || hasMethods || hasLoggedMissingDeliveryMethods) {
        return;
      }
      hasLoggedMissingDeliveryMethods = true;
      kibanaLogger.error(
        'Data Builder root response has no delivery_methods; falling back to download-only delivery',
        { context: 'data-builder-delivery-methods' }
      );
    }, [isLoaded, hasMethods]);

    return {
      availableMethods: hasMethods ? deliveryMethods : DOWNLOAD_ONLY_FALLBACK,
      isLoaded,
    };
  };
